/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkCupStrawIcon24Solid = forwardRef('FoodDrinkCupStrawIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.881 2.255c-.44 0-.81.326-.868.762L13.624 6h3.224a2.25 2.25 0 0 1 2.24 2.467l-1.145 11.822a3 3 0 0 1-2.986 2.71H9.043a3 3 0 0 1-2.986-2.71L4.913 8.467A2.25 2.25 0 0 1 7.153 6h4.202l.427-3.274a3.125 3.125 0 0 1 3.1-2.721h4.243a1.125 1.125 0 0 1 0 2.25h-4.244ZM8 9a.75.75 0 1 0 0 1.5h8A.75.75 0 0 0 16 9H8Z" })));
});
